import React, { useState, useContext, useEffect } from "react";
import "./MatchUpdates.css";
import "../PlaceBet/PlaceBet.css";
// import "../../../src/App.css";
import { Modal, Switch } from "antd";
import Header from "../header/Header";
import Footer from "../Footer/Footer";
import { IoInformationCircleOutline } from "react-icons/io5";
import { FaPlayCircle } from "react-icons/fa";
import { MdLiveTv } from "react-icons/md";
import FancyMarket from "../FancyMarket/FancyMarket";
import PlaceBetSuccessfull from "../PlaceBetSuccesfull/PlaceBetSuccessfull";
import Empty from "../EmptyDiv/Empty";
import { TimeContext } from "../TimeContext/TimeContext";
import { getMatchData } from "../../redux/slice/eventData/eventDataSlice";
import { getMatchFancyData } from "../../redux/slice/fancyData/fancyDataSlice";
import { getUserBal } from "../../redux/slice/user/userSlice";
import Helper from "../../helper";
import { useSelector, useDispatch } from "react-redux";
import { WebSocketContext } from "../../components/Context/websocket";
import axios from "axios";
import Appconfig from "../../config/config";
import { useNavigate, useParams } from "react-router-dom";
import PlaceBet from "../PlaceBet/index";
import { setData } from "../../redux/slice/betting/bettingSlice";
import ExposureHeader from "../ExposureHeader/ExposureHeader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollGames from "../ScrollGames/ScrollGames";
import SideBarMenue from "../SideBarMenue/SideBarMenue";
import OpenBets from "../OpenBets/OpenBets";
import RightSection from "../RightSection/RightSection";
import { getAllBets } from '../../redux/slice/openBet/openBetSlice';
import { TbScoreboard, GrScorecard } from "react-icons/tb";
import { useAuth } from "../AuthContext";


const MatchUpdates = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfos = useSelector((state) => state.eventData); // Use selector to access state
  const userFancyData = useSelector((state) => state.fancyData); // Use selector to access state
  const userbalance = useSelector((state) => state.userbal); // Use selector to access state
  const balance = userbalance?.userBalance?.balance;
  const userInfo = Helper(); // get login user details
  // const openbets = useSelector((state) => state.bets);
  const websocket = useContext(WebSocketContext);
  const { setBetPlaced } = useAuth();

  const { event_id, is_inplay } = useParams();

  const [showPlaceBetPopup, setShowPlaceBetPopup] = useState(false);
  const [betType, setBetType] = useState(null);
  const [amount, setAmount] = useState(0); // State for amount in PlaceBet popup
  const [showIframe, setShowIframe] = useState(true); // State to manage iframe visibility
  const [showLtv, setShowLtv] = useState(false);
  const [showScore, setShowScore] = useState(false)
  const [tvUrl, setTvUrl] = useState();
  const [showScoreIfram, setShowScoreIfram] = useState(false);
  const [showMatchStatus, setShowMatchStatus] = useState(true); // State for Match Status visibility
  const [showOpenBets, setShowOpenBets] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false); // State for success message popup
  const [betAmount, setBetAmount] = useState(false);
  const { matchTime } = useContext(TimeContext);
  const [betSource, setBetSource] = useState(""); // State to track if it's from 'Match Odds' or 'Bookmaker'
  const [teamName, setTeamName] = useState(""); // State for team name

  const [marketTypes, setMarketTypes] = useState([]);
  const [blockMatchOdds, setBlockMatchOdds] = useState({});
  const [blockBookmaker, setBlockBookmaker] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [scoreUrl, setScoreUrl] = useState("");
  const [eventData, setEventData] = useState([]);
  const [fancy, setFancy] = useState([]);
  const [eventType, setEventType] = useState("");
  const [eventName, setEventName] = useState("");
  const [openDate, setOpenDate] = useState("");
  const [betsData, setBetsData] = useState([]);
  const [matchOdds, setMatchOdds] = useState("");
  const [bookmaker, setBookmaker] = useState("");
  const [isEventLoading, setIsEventLoading] = useState(true);
  const [selectionIdNew, setSelectionIdNew] = useState("");
  const [is_fancy, setIs_fancy] = useState(false);
  const [fancyOddsData, setFancyOddsData] = useState([]);
  const [isReady, setIsReady] = useState(false);
  const match_odds_bet_limit = 20;
  const [generalSetting, setGeneralSetting] = useState([]);
  const [fancyExposure, setFancyExposure] = useState([]);
  const [chips, setChips] = useState([]);
  const [showBetsSlip, setShowBetsSlip] = useState(false);
  const [selection_id, setSelection_id] = useState("");
  const [marketId, setMarketId] = useState("");
  const [type, setType] = useState("back");

  const [htmlId, setHtmlId] = useState("");
  const [size, setSize] = useState("");
  const [ProfitValue, setProfitValue] = useState(0);
  const [lossValue, setLossValue] = useState(0);
  const [StakeValue, setStakeValue] = useState(0);
  const [defaultStake, setDefaultStake] = useState(0);
  const [BetPlaceData, setBetPlaceData] = useState({
    event_id: "",
    market_id: "",
    is_back: "",
    price: "",
    is_fancy: "",
    selection_id: "",
    runner_name: "",
    PM_FANCY: false,
  });
  const [placing, setPlacing] = useState(false);
  const [isBetPlaced, setIsBetPlaced] = useState(false);

  const [postionFancyList, setPostionFancyList] = useState([]);
  const [bookModalOpen, setBookModalOpen] = useState(false);
  const [isInplay, setIsInplay] = useState(false);
  const [activeButton, setActiveButton] = useState('market'); // default active
  const openbets = useSelector((state) => state.bets); // Use selector to access state
  const [fancyBets, setFancyBets] = useState([]);
  const [matchBets, setMatchBets] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isScoreboardOnTop, setIsScoreboardOnTop] = useState(false);
  const openBetsCount = event_id && openbets?.bets
    ? openbets.bets.filter(bet => bet.match_id === event_id).length
    : 0;

  // // placebet open time start code
  // useEffect(() => {
  //   // Only set a timer when the popup is shown
  //   if (showPlaceBetPopup) {
  //     // Set a timer to hide the popup after 7 seconds (7000 ms)
  //     const timer = setTimeout(() => {
  //       setShowPlaceBetPopup(false);
  //       // Always remove position value when auto close
  //       setPostionFancyList([]);
  //     }, 7000);

  //     // Cleanup: clear timer if popup closes early or component unmounts
  //     return () => clearTimeout(timer);
  //   }
  // }, [showPlaceBetPopup]);

  // //  placebet open time end code

  // // 2. Create a function to flip the value of `isOpen`.
  // const handleToggle = () => {
  //   setIsOpen(!isOpen); // Sets `isOpen` to the opposite of its current value.
  // };

  const getOpenBetsByEvent = async () => {
    dispatch(getAllBets({
      user_id: userInfo?._id,
    }))
  }

  useEffect(() => {
    getOpenBetsByEvent()
  }, [])

  useEffect(() => {
    if (openbets?.bets?.length > 0) {
      let openBetsData = openbets?.bets;
      let fancyOpenBets = openBetsData?.filter(fancy => fancy.betting_type == "Fancy");
      let matchOpenBets = openBetsData?.filter(match => match.betting_type == "Match");
      setFancyBets(fancyOpenBets);
      setMatchBets(matchOpenBets);
    }
  }, [openbets])


  function SetPosition(stake, priceVal, market_id, is_back, selection_id) {
    priceVal = parseFloat(priceVal);
    var MarketId = market_id;
    var MId = MarketId.replace(".", "");
    var selectionId = selection_id;
    var isback = is_back;
    stake = parseFloat(stake);
    let MatchMarketTypes = "";
    var runners = document.getElementsByClassName("position_" + MId);
    var tempRunners = "";
    for (var item of runners) {
      var selecid = item.getAttribute("data-id");
      var winloss = parseFloat(item.value);
      var curr = 0;
      if (selectionId == selecid) {
        if (isback) {
          if (MatchMarketTypes == "M") {
            curr = winloss + (priceVal * stake) / 100;
          } else {
            curr = winloss + (priceVal * stake - stake);
          }
        } else {
          if (MatchMarketTypes == "M") {
            curr = winloss + -1 * parseFloat((priceVal * stake) / 100);
          } else {
            curr = winloss + -1 * parseFloat(priceVal * stake - stake);
          }
        }
      } else {
        if (isback == 1) {
          curr = winloss + -1 * stake;
        } else {
          curr = winloss + stake;
        }
      }
      var currV = curr;
      if (
        document.getElementById(selecid + "_maxprofit_loss_runner_prev_" + MId)
      ) {
        document
          .getElementById(selecid + "_maxprofit_loss_runner_prev_" + MId)
          .setAttribute("data-value", winloss.toFixed(2));
        document.getElementById(
          selecid + "_maxprofit_loss_runner_prev_" + MId
        ).innerHTML = Math.abs(winloss.toFixed(2));
      }
      if (
        document.getElementById(
          selecid + "_maxprofit_list_loss_runner_next_" + MId
        )
      ) {
        document
          .getElementById(selecid + "_maxprofit_list_loss_runner_next_" + MId)
          .setAttribute("data-value", currV.toFixed(2));
        document.getElementById(
          selecid + "_maxprofit_list_loss_runner_next_" + MId
        ).innerHTML = Math.abs(currV.toFixed(2));
      }
      if (
        document.getElementById(
          selecid + "_maxprofit_Mlist_loss_runner_next_" + MId
        )
      ) {
        document
          .getElementById(selecid + "_maxprofit_Mlist_loss_runner_next_" + MId)
          .setAttribute("data-value", currV.toFixed(2));
        document.getElementById(
          selecid + "_maxprofit_Mlist_loss_runner_next_" + MId
        ).innerHTML = Math.abs(currV.toFixed(2));
      }
    }
  }
  const placeStakeValue = (stake) => {
    if (String(stake).startsWith("NaN")) {
      stake = String(stake).replace("NaN", "");
    }
    setStakeValue(parseFloat(stake));
    calc(stake, BetPlaceData.price, BetPlaceData.selection_id);
    SetPosition(
      stake,
      BetPlaceData.price,
      BetPlaceData.market_id,
      BetPlaceData.is_back,
      BetPlaceData.selection_id
    );
  };

  function calc(t_stake, priceVal, selection_id) {
    var isfancy = BetPlaceData.is_fancy;
    priceVal = parseFloat(priceVal);
    t_stake = parseFloat(t_stake);
    var isback = BetPlaceData.is_back;
    if (!isfancy) {
      var pl = priceVal * t_stake - t_stake;

      pl = parseFloat(pl.toFixed(2));
      if (isback) {
        setProfitValue(pl);
        setLossValue(t_stake);
      } else {
        setLossValue(pl);
        setProfitValue(t_stake);
      }
      // SetPosition(priceVal);
    } else {
      if (document.getElementById("fancy_lay_size_" + selection_id)) {
        var NoValume = parseInt(
          document.getElementById("fancy_lay_size_" + selection_id).innerHTML
        );
        var YesValume = parseInt(
          document.getElementById("fancy_back_size_" + selection_id).innerHTML
        );
        var inputno = parseFloat(
          document.getElementById(`fancy_lay_price_${selection_id}`).innerHTML
        );
        var inputyes = parseFloat(
          document.getElementById(`fancy_back_price_${selection_id}`).innerHTML
        );
      }

      pl = parseFloat(t_stake);

      if (inputno == inputyes) {
        if (isback) {
          setLossValue(pl.toFixed(2));
          setProfitValue(((YesValume * pl) / 100).toFixed(2));
        } else {
          setLossValue(((NoValume * pl) / 100).toFixed(2));
          setProfitValue(pl.toFixed(2));
        }
      } else {
        setLossValue(pl.toFixed(2));
        setProfitValue(pl.toFixed(2));
      }
    }
  }

  useEffect(() => {
    marketTypes?.map((market) => {
      if (market?.market_name == "Match Odds") {
        getBlockMatchOdds(market.event_id, market.market_id);
      } else if (market?.market_name == "Bookmaker") {
        getBlockBookmaker(market.event_id, market.market_id);
      }
    });
  }, [marketTypes]);

  const getFancyExposure = (selectionId) => {
    let findItem = fancyExposure.find(
      (item) => item.selection_id == selectionId
    );

    if (findItem) {
      return findItem?.min;
    } else {
      return false;
    }
  };

  const checkFancyExposureExists = (selectionId) => {
    let findItem = fancyExposure.find(
      (item) => item.selection_id == selectionId
    );

    if (findItem) {
      return true;
    } else {
      return false;
    }
  };

  function getBlockMatchOdds(event_id, market_id) {
    var data = JSON.stringify({
      user_id: Appconfig.superAdmin,
      event_id: event_id,
      market_id: market_id,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}blockMarket/getBlockMatchOdds`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          // alert("Hello");
          // console.log('response.data', response.data)
          if (response.data.result) {
            setBlockMatchOdds(response.data.resultData[0]);
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        console.log(error);
        // postErrorToslack(error.message);
      });
  }

  function getBlockBookmaker(event_id, market_id) {
    var data = JSON.stringify({
      user_id: Appconfig.superAdmin,
      event_id: event_id,
      market_id: market_id,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}blockMarket/getBlockMatchOdds`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          // alert("Hello");
          // console.log('response.data', response.data)
          if (response.data.result) {
            setBlockBookmaker(response.data.resultData[0]);
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        console.log(error);
        // postErrorToslack(error.message);
      });
  }

  useEffect(() => {
    if (userInfo) {
      dispatch(
        getUserBal({
          user_id: userInfo?._id,
        })
      );
    }
  }, [userInfo?._id]);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, []);

  useEffect(() => {
    getScoreUrl(event_id);
  }, [event_id]);

  function getFancyPosition(selectionId) {
    if (userInfo) {
      var data = JSON.stringify({
        user_id: userInfo._id,
        event_id: event_id,
        fancy_id: selectionId,
      });
      var config = {
        method: "post",
        url: `${Appconfig.apiUrl}betting/getFancyPosition`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then(function (response) {
          try {
            setPostionFancyList(response.data.resultData);
            setBookModalOpen(true);
          } catch (e) {
            console.log(e);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      navigate("/login");
    }
  }

  function getScoreUrl(eventId) {
    var data = JSON.stringify({
      event_id: eventId,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}eventsDashboard/getScore`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          // alert("Hello");
          // setScoreUrl(response.data.resultData.animation);
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        console.log(error);
        // postErrorToslack(error.message);
      });
    // }
  }


  useEffect(() => {
    // console.log('openBEts : ', openbets);
    if (openbets?.bets?.length > 0) {
      let openBetsData = [];
      if (event_id) {
        openBetsData = openbets?.bets?.filter(
          (item) => item.match_id == event_id
        );
      }
      setBetsData(openBetsData);
      // console.log('openBEts data : ', openBetsData);
    }
  }, [openbets, event_id]);
  useEffect(() => {
    var data;
    if (userInfo) {
      data = {
        user_id: userInfo._id,
        event_id: event_id,
      };
    } else {
      data = {
        event_id: event_id,
      };
    }
    dispatch(getMatchData(data));
  }, []);

  useEffect(() => {
    if (userInfos.eventData[event_id]) {
      setEventData(userInfos.eventData[event_id]);
      setMarketTypes(userInfos.eventData[event_id][0]?.marketTypes);
      setFancy(userInfos.eventData[event_id][0]?.fancy);
      setScoreUrl(`https://trovetown.co/score/sportRadar/?eventId=${userInfos.eventData[event_id][0]?.betfair_event_id}`)
      setTvUrl(userInfos.eventData[event_id][0]?.tv_link);
      let eventType = userInfos.eventData[event_id][0];
      if (eventType?.event_type == 4) {
        setEventType("Cricket");
      } else if (eventType?.event_type == 2) {
        setEventType("Tennis");
      } else {
        setEventType("Soccer");
      }
      setEventName(eventType?.event_name);
      setOpenDate(eventType?.open_date);
      setIsInplay(eventType?.is_inplay == "True" ? true : false);

      userInfos.eventData[event_id][0]?.marketTypes?.map((type) => {
        if (type.market_name == "Bookmaker") {
          setBookmaker(type);
        }
        if (type.market_name == "Match Odds") {
          setMatchOdds(type);
        }
      });
      setIsEventLoading(false);
    }
  }, [userInfos.eventData[event_id]]);

  useEffect(() => {
    dispatch(
      getMatchFancyData({
        event_id: event_id,
        user_id: userInfo ? userInfo._id : "",
      })
    );
  }, []);

  useEffect(() => {
    if (userFancyData.fancyData[event_id]) {
      fancyHtml(userFancyData?.fancyData[event_id]);
    }
  }, [userFancyData.fancyData[event_id]]);

  async function fancyHtml(fancys) {
    var superiors = ["270", "259", "185", "177", "30"];
    var matchId = event_id;
    if (matchId) {
      if (fancys) {
        let check_new_fields_added = false;

        const result = fancys.find((item) => {
          // console.log(
          //   `Checking item with selection_id: ${item.selection_id
          //   }, game_status: ${item.game_status}, selectionIdNew: ${String(
          //     selectionIdNew
          //   )}`
          // );

          const gameStatusMatch =
            item.game_status === "SUSPENDED" ||
            item.game_status === "Ball Running";
          const selectionIdMatch =
            String(item.selection_id) === String(selectionIdNew);

          // console.log(
          //   `gameStatusMatch: ${gameStatusMatch}, selectionIdMatch: ${selectionIdMatch}`
          // );

          return gameStatusMatch && selectionIdMatch;
        });

        // const result = fancys.find(item => item.game_status === "" && item.selection_id === selection_id);
        if (result) {
          setIs_fancy(false);
        }

        setFancyOddsData(fancys);
      }
    }
  }

  useEffect(() => {
    if (websocket) {
      websocket.onopen = () => {
        console.log("Websocket is open ", new Date());
        setIsReady(true);
      };

      if (websocket.readyState) {
        console.log("WESOCKET JOIN REQUEST SENT", {
          action: "JOIN",
          data: {
            username: "suthard444",
            event_id: event_id,
          },
        });

        websocket.send(
          JSON.stringify({
            action: "JOIN",
            data: {
              username: "suthard444",
              event_id: event_id,
            },
          })
        );
      }
    }
  }, [websocket, event_id, isReady]);

  useEffect(() => {
    if (websocket) {
      websocket.onmessage = (evt) => {
        const data = JSON.parse(evt.data);
        if (data.action == "MARKET_UPDATE") {
          // console.log("MARKET SOCKET RESPONDING");
          let market = data.data;
          // console.log("market", market);
          if (market) {
            if (market.market_types.length > 0) {
              market.market_types.map((market_type, index) => {
                market_type.hasOwnProperty("runners") &&
                  market_type.runners.map((runner, index) => {
                    // if (market_type.status == 'OPEN') {
                    // } else {
                    // }

                    // if (runner.market_id == '4.1680554980-BM') {
                    // }
                    if (
                      checkHighestMarketPrice(runner, market_type.market_name)
                    ) {
                      if (
                        runner.status == "SUSPENDED" ||
                        market_type.status == "CLOSED"
                      ) {
                        const selecid = runner.selection_id;
                        const suspendedDiv = document.querySelector(
                          `.suspended_${runner.market_id.replace(
                            ".",
                            ""
                          )}_${selecid}`
                        );
                        const suspendedMDiv = document.querySelector(
                          `.Msuspended_${runner.market_id.replace(
                            ".",
                            ""
                          )}_${selecid}`
                        );
                        const suspendedMSOCCERDiv = document.querySelector(
                          `.m-soccer-suspended_${runner.market_id.replace(
                            ".",
                            ""
                          )}_${selecid}`
                        );
                        const suspendedSOCCERDiv = document.querySelector(
                          `.soccer-suspended_${runner.market_id.replace(
                            ".",
                            ""
                          )}_${selecid}`
                        );
                        if (suspendedDiv) {
                          suspendedDiv &&
                            suspendedDiv.classList.remove("hidden");
                        }
                        if (suspendedMDiv) {
                          suspendedMDiv &&
                            suspendedMDiv.classList.remove("hidden");
                        }
                        if (suspendedMSOCCERDiv) {
                          suspendedMSOCCERDiv &&
                            suspendedMSOCCERDiv.classList.remove("hidden");
                        }
                        if (suspendedSOCCERDiv) {
                          suspendedSOCCERDiv &&
                            suspendedSOCCERDiv.classList.remove("hidden");
                        }
                      } else {
                        const selecid = runner.selection_id;
                        const suspendedDiv = document.querySelector(
                          `.suspended_${runner.market_id.replace(
                            ".",
                            ""
                          )}_${selecid}`
                        );
                        const suspendedMDiv = document.querySelector(
                          `.Msuspended_${runner.market_id.replace(
                            ".",
                            ""
                          )}_${selecid}`
                        );
                        const suspendedMSOCCERDiv = document.querySelector(
                          `.m-soccer-suspended_${runner.market_id.replace(
                            ".",
                            ""
                          )}_${selecid}`
                        );
                        const suspendedSOCCERDiv = document.querySelector(
                          `.soccer-suspended_${runner.market_id.replace(
                            ".",
                            ""
                          )}_${selecid}`
                        );
                        if (suspendedDiv) {
                          suspendedDiv && suspendedDiv.classList.add("hidden");
                        }
                        if (suspendedMDiv) {
                          suspendedMDiv &&
                            suspendedMDiv.classList.add("hidden");
                        }
                        if (suspendedMSOCCERDiv) {
                          suspendedMSOCCERDiv &&
                            suspendedMSOCCERDiv.classList.add("hidden");
                        }
                        if (suspendedSOCCERDiv) {
                          suspendedSOCCERDiv &&
                            suspendedSOCCERDiv.classList.add("hidden");
                        }
                      }
                      const boxes = document.querySelectorAll(
                        ".market_runners_" +
                        runner.market_id.replace(".", "") +
                        "_" +
                        runner.selection_id
                      );
                      for (const box of boxes) {
                        box.classList.add("disabled");
                      }
                    } else {
                      const boxes = document.querySelectorAll(
                        ".market_runners_" +
                        runner.market_id.toString().replace(".", "") +
                        "_" +
                        runner.selection_id
                      );
                      for (const box of boxes) {
                        box.classList.remove("disabled");
                      }
                    }

                    var match_odd_row = document.getElementsByClassName(
                      "table_row_" +
                      runner.market_id.toString().replace(".", "") +
                      "_" +
                      runner.selection_id
                    )[0];

                    if (
                      runner.status == "SUSPENDED" ||
                      runner.status == "CLOSE" ||
                      runner.status == "CLOSED"
                    ) {
                      if (
                        document.getElementById(
                          "availableToLay1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                      ) {
                        if (match_odd_row) {
                          match_odd_row.setAttribute(
                            "data-title",
                            runner.status
                          );
                          match_odd_row.parentElement.classList.add(
                            "suspended"
                          );
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "availableToBack1_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.back_1_price)
                        ) {
                        } else {
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "availableToLay1_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.lay_1_price)
                        ) {
                        } else {
                        }
                      }
                      // mobile{
                      if (
                        document.getElementById(
                          "MavailableToLay1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                      ) {
                        if (match_odd_row) {
                          match_odd_row.setAttribute(
                            "data-title",
                            runner.status
                          );
                          match_odd_row.parentElement.classList.add(
                            "suspended"
                          );
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "MavailableToBack1_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.back_1_price)
                        ) {
                        } else {
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "MavailableToLay1_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.lay_1_price)
                        ) {
                        } else {
                        }
                      }
                      // }
                      if (
                        document.getElementById(
                          "availableToLay2_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                      ) {
                        if (match_odd_row) {
                          match_odd_row.setAttribute(
                            "data-title",
                            runner.status
                          );
                          match_odd_row.parentElement.classList.add(
                            "suspended"
                          );
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "availableToBack2_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.back_2_price)
                        ) {
                        } else {
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "availableToLay2_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.lay_2_price)
                        ) {
                        } else {
                        }
                      }
                      if (
                        document.getElementById(
                          "availableToLay3_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                      ) {
                        if (match_odd_row) {
                          match_odd_row.setAttribute(
                            "data-title",
                            runner.status
                          );
                          match_odd_row.parentElement.classList.add(
                            "suspended"
                          );
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "availableToBack3_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.back_3_price)
                        ) {
                        } else {
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "availableToLay3_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.lay_3_price)
                        ) {
                        } else {
                        }
                      }
                    } else {
                      if (
                        document.getElementById(
                          "availableToLay1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                      ) {
                        if (match_odd_row) {
                          match_odd_row.parentElement.setAttribute(
                            "data-title",
                            ""
                          );
                          match_odd_row.parentElement.classList.remove(
                            "suspended"
                          );
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "availableToBack1_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.back_1_price)
                        ) {
                          document.getElementById(
                            "availableToBack1_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.back_1_price);
                        } else {
                          document.getElementById(
                            "availableToBack1_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.back_1_price);
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "availableToLay1_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.lay_1_price)
                        ) {
                          document.getElementById(
                            "availableToLay1_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.lay_1_price);
                        } else {
                          document.getElementById(
                            "availableToLay1_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.lay_1_price);
                        }
                      }
                      // mobile{
                      if (
                        document.getElementById(
                          "MavailableToLay1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                      ) {
                        if (match_odd_row) {
                          match_odd_row.parentElement.setAttribute(
                            "data-title",
                            ""
                          );
                          match_odd_row.parentElement.classList.remove(
                            "suspended"
                          );
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "MavailableToBack1_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.back_1_price)
                        ) {
                          document.getElementById(
                            "MavailableToBack1_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.back_1_price);
                        } else {
                          document.getElementById(
                            "MavailableToBack1_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.back_1_price);
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "MavailableToLay1_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.lay_1_price)
                        ) {
                          document.getElementById(
                            "MavailableToLay1_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.lay_1_price);
                        } else {
                          document.getElementById(
                            "MavailableToLay1_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.lay_1_price);
                        }
                      }
                      // }
                      if (
                        document.getElementById(
                          "availableToLay2_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                      ) {
                        if (match_odd_row) {
                          match_odd_row.parentElement.setAttribute(
                            "data-title",
                            ""
                          );
                          match_odd_row.parentElement.classList.remove(
                            "suspended"
                          );
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "availableToBack2_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.back_2_price)
                        ) {
                          document.getElementById(
                            "availableToBack2_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.back_2_price);
                        } else {
                          document.getElementById(
                            "availableToBack2_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.back_2_price);
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "availableToLay2_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.lay_2_price)
                        ) {
                          document.getElementById(
                            "availableToLay2_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.lay_2_price);
                        } else {
                          document.getElementById(
                            "availableToLay2_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.lay_2_price);
                        }
                      }
                      if (
                        document.getElementById(
                          "availableToLay3_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                      ) {
                        if (match_odd_row) {
                          match_odd_row.parentElement.setAttribute(
                            "data-title",
                            ""
                          );
                          match_odd_row.parentElement.classList.remove(
                            "suspended"
                          );
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "availableToBack3_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.back_3_price)
                        ) {
                          document.getElementById(
                            "availableToBack3_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.back_3_price);
                        } else {
                          document.getElementById(
                            "availableToBack3_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.back_3_price);
                        }
                        if (
                          parseFloat(
                            document.getElementById(
                              "availableToLay3_price_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            ).innerHTML
                          ) != parseFloat(runner.lay_3_price)
                        ) {
                          document.getElementById(
                            "availableToLay3_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.lay_3_price);
                        } else {
                          document.getElementById(
                            "availableToLay3_price_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML = parseFloat(runner.lay_3_price);
                        }
                      }
                    }
                    /************************Size */

                    if (
                      document.getElementById(
                        "availableToBack1_size_" +
                        runner.market_id.replace(".", "") +
                        "_" +
                        runner.selection_id
                      )
                    ) {
                      document
                        .getElementById(
                          "availableToBack1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                        .parentElement.classList.remove("spark");
                      document
                        .getElementById(
                          "availableToLay1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                        .parentElement.classList.remove("spark");
                      if (
                        parseFloat(
                          document.getElementById(
                            "availableToBack1_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML
                        ) != parseFloat(runner.back_1_size)
                      ) {
                        document
                          .getElementById(
                            "availableToBack1_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          )
                          .parentElement.classList.add("spark");
                        setTimeout(function () {
                          if (
                            document.getElementById(
                              "availableToBack1_size_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            )
                          )
                            document
                              .getElementById(
                                "availableToBack1_size_" +
                                runner.market_id.replace(".", "") +
                                "_" +
                                runner.selection_id
                              )
                              .parentElement.classList.remove("spark");
                        }, 700);
                        document.getElementById(
                          "availableToBack1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.back_1_size);
                      } else {
                        document.getElementById(
                          "availableToBack1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.back_1_size);
                      }
                      if (
                        parseFloat(
                          document.getElementById(
                            "availableToLay1_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML
                        ) != parseFloat(runner.lay_1_size)
                      ) {
                        document
                          .getElementById(
                            "availableToLay1_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          )
                          .parentElement.classList.add("spark");
                        document.getElementById(
                          "availableToLay1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.lay_1_size);
                        setTimeout(function () {
                          if (
                            document.getElementById(
                              "availableToBack1_size_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            )
                          )
                            document
                              .getElementById(
                                "availableToLay1_size_" +
                                runner.market_id.replace(".", "") +
                                "_" +
                                runner.selection_id
                              )
                              .parentElement.classList.remove("spark");
                        }, 700);
                      } else {
                        document.getElementById(
                          "availableToLay1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.lay_1_size);
                      }
                    }
                    // mobile
                    if (
                      document.getElementById(
                        "MavailableToBack1_size_" +
                        runner.market_id.replace(".", "") +
                        "_" +
                        runner.selection_id
                      )
                    ) {
                      document
                        .getElementById(
                          "MavailableToBack1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                        .parentElement.classList.remove("spark");
                      document
                        .getElementById(
                          "MavailableToLay1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                        .parentElement.classList.remove("spark");
                      if (
                        parseFloat(
                          document.getElementById(
                            "MavailableToBack1_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML
                        ) != parseFloat(runner.back_1_size)
                      ) {
                        document
                          .getElementById(
                            "MavailableToBack1_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          )
                          .parentElement.classList.add("spark");
                        setTimeout(function () {
                          if (
                            document.getElementById(
                              "MavailableToBack1_size_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            )
                          )
                            document
                              .getElementById(
                                "MavailableToBack1_size_" +
                                runner.market_id.replace(".", "") +
                                "_" +
                                runner.selection_id
                              )
                              .parentElement.classList.remove("spark");
                        }, 700);
                        document.getElementById(
                          "MavailableToBack1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.back_1_size);
                      } else {
                        document.getElementById(
                          "MavailableToBack1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.back_1_size);
                      }
                      if (
                        parseFloat(
                          document.getElementById(
                            "MavailableToLay1_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML
                        ) != parseFloat(runner.lay_1_size)
                      ) {
                        document
                          .getElementById(
                            "MavailableToLay1_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          )
                          .parentElement.classList.add("spark");
                        document.getElementById(
                          "MavailableToLay1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.lay_1_size);
                        setTimeout(function () {
                          if (
                            document.getElementById(
                              "MavailableToBack1_size_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            )
                          )
                            document
                              .getElementById(
                                "MavailableToLay1_size_" +
                                runner.market_id.replace(".", "") +
                                "_" +
                                runner.selection_id
                              )
                              .parentElement.classList.remove("spark");
                        }, 700);
                      } else {
                        document.getElementById(
                          "MavailableToLay1_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.lay_1_size);
                      }
                    }
                    // }
                    if (
                      document.getElementById(
                        "availableToBack2_size_" +
                        runner.market_id.replace(".", "") +
                        "_" +
                        runner.selection_id
                      )
                    ) {
                      document
                        .getElementById(
                          "availableToBack2_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                        .parentElement.classList.remove("spark");
                      document
                        .getElementById(
                          "availableToLay2_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                        .parentElement.classList.remove("spark");
                      if (
                        parseFloat(
                          document.getElementById(
                            "availableToBack2_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML
                        ) != parseFloat(runner.back_2_size)
                      ) {
                        document
                          .getElementById(
                            "availableToBack2_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          )
                          .parentElement.classList.add("spark");
                        setTimeout(function () {
                          if (
                            document.getElementById(
                              "availableToBack2_size_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            )
                          )
                            document
                              .getElementById(
                                "availableToBack2_size_" +
                                runner.market_id.replace(".", "") +
                                "_" +
                                runner.selection_id
                              )
                              .parentElement.classList.remove("spark");
                        }, 700);
                        document.getElementById(
                          "availableToBack2_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.back_2_size);
                      } else {
                        document.getElementById(
                          "availableToBack2_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.back_2_size);
                      }
                      if (
                        parseFloat(
                          document.getElementById(
                            "availableToLay2_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML
                        ) != parseFloat(runner.lay_2_size)
                      ) {
                        document
                          .getElementById(
                            "availableToLay2_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          )
                          .parentElement.classList.add("spark");
                        document.getElementById(
                          "availableToLay2_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.lay_2_size);
                        setTimeout(function () {
                          if (
                            document.getElementById(
                              "availableToBack2_size_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            )
                          )
                            document
                              .getElementById(
                                "availableToLay2_size_" +
                                runner.market_id.replace(".", "") +
                                "_" +
                                runner.selection_id
                              )
                              .parentElement.classList.remove("spark");
                        }, 700);
                      } else {
                        document.getElementById(
                          "availableToLay2_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.lay_2_size);
                      }
                    }
                    if (
                      document.getElementById(
                        "availableToBack3_size_" +
                        runner.market_id.replace(".", "") +
                        "_" +
                        runner.selection_id
                      )
                    ) {
                      document
                        .getElementById(
                          "availableToBack3_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                        .parentElement.classList.remove("spark");
                      document
                        .getElementById(
                          "availableToLay3_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        )
                        .parentElement.classList.remove("spark");
                      if (
                        parseFloat(
                          document.getElementById(
                            "availableToBack3_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML
                        ) != parseFloat(runner.back_3_size)
                      ) {
                        document
                          .getElementById(
                            "availableToBack3_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          )
                          .parentElement.classList.add("spark");
                        setTimeout(function () {
                          if (
                            document.getElementById(
                              "availableToBack3_size_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            )
                          )
                            document
                              .getElementById(
                                "availableToBack3_size_" +
                                runner.market_id.replace(".", "") +
                                "_" +
                                runner.selection_id
                              )
                              .parentElement.classList.remove("spark");
                        }, 700);
                        document.getElementById(
                          "availableToBack3_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.back_3_size);
                      } else {
                        document.getElementById(
                          "availableToBack3_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.back_3_size);
                      }
                      if (
                        parseFloat(
                          document.getElementById(
                            "availableToLay3_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          ).innerHTML
                        ) != parseFloat(runner.lay_3_size)
                      ) {
                        document
                          .getElementById(
                            "availableToLay3_size_" +
                            runner.market_id.replace(".", "") +
                            "_" +
                            runner.selection_id
                          )
                          .parentElement.classList.add("spark");
                        document.getElementById(
                          "availableToLay3_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.lay_3_size);
                        setTimeout(function () {
                          if (
                            document.getElementById(
                              "availableToBack3_size_" +
                              runner.market_id.replace(".", "") +
                              "_" +
                              runner.selection_id
                            )
                          )
                            document
                              .getElementById(
                                "availableToLay3_size_" +
                                runner.market_id.replace(".", "") +
                                "_" +
                                runner.selection_id
                              )
                              .parentElement.classList.remove("spark");
                        }, 700);
                      } else {
                        document.getElementById(
                          "availableToLay3_size_" +
                          runner.market_id.replace(".", "") +
                          "_" +
                          runner.selection_id
                        ).innerHTML = parseFloat(runner.lay_3_size);
                      }
                    }
                  });
              });
            }
          }
        }
        // console.log('data111', data);

        if (data.action == "FANCY_UPDATE") {
          let market = data.data;
          // console.log('market', market);
          console.log("FANCY SOCKET RESPONDING");
          if (market) {
            if (market?.fancy_data.length) {
              fancyHtml(market?.fancy_data);
            }

            // fancyHtml(market)
          }
        }
      };
    }
  }, [websocket, event_id]);

  const checkHighestMarketPrice = (runner, market_name) => {
    let price_exceed_by_limit = false;
    // await Promise.all(
    // 1
    if (runner.market_id.toString().includes("BM")) {
      if (runner.back_1_price > 0) {
        if (parseFloat(runner.back_1_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.lay_1_price > 0) {
        if (parseFloat(runner.lay_1_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.back_1_price <= 0) {
        price_exceed_by_limit = true;
      }

      if (runner.lay_1_price <= 0) {
      }
    } else if (
      market_name == "Bookmaker" ||
      market_name == "Bookmaker 2" ||
      market_name == "TIED_MATCH"
    ) {
      if (runner.back_1_price > 0) {
        if (parseFloat(runner.back_1_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.lay_1_price > 0) {
        if (parseFloat(runner.lay_1_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.back_1_price <= 0) {
        price_exceed_by_limit = true;
      }

      if (runner.lay_1_price <= 0) {
      }
    } else {
      if (
        parseFloat(runner.back_1_price) > match_odds_bet_limit ||
        parseFloat(runner.lay_1_price) > match_odds_bet_limit
      ) {
        price_exceed_by_limit = true;
      }

      if (
        parseFloat(runner.back_1_price) <= 0 &&
        parseFloat(runner.lay_1_price) <= 0
      ) {
        price_exceed_by_limit = true;
      }
    }

    // 2
    if (runner.market_id.toString().includes("BM")) {
      if (runner.back_2_price > 0) {
        if (parseFloat(runner.back_2_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.lay_2_price > 0) {
        if (parseFloat(runner.lay_2_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.back_2_price <= 0) {
        price_exceed_by_limit = true;
      }

      if (runner.lay_2_price <= 0) {
      }
    } else if (
      market_name == "Bookmaker" ||
      market_name == "Bookmaker 2" ||
      market_name == "TIED_MATCH"
    ) {
      if (runner.back_2_price > 0) {
        if (parseFloat(runner.back_2_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.lay_2_price > 0) {
        if (parseFloat(runner.lay_2_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.back_2_price <= 0) {
        price_exceed_by_limit = true;
      }

      if (runner.lay_2_price <= 0) {
      }
    } else {
      if (
        parseFloat(runner.back_2_price) > match_odds_bet_limit ||
        parseFloat(runner.lay_2_price) > match_odds_bet_limit
      ) {
        price_exceed_by_limit = true;
      }

      if (
        parseFloat(runner.back_2_price) <= 0 &&
        parseFloat(runner.lay_2_price) <= 0
      ) {
        price_exceed_by_limit = true;
      }
    }

    // 3
    if (runner.market_id.toString().includes("BM")) {
      if (runner.back_3_price > 0) {
        if (parseFloat(runner.back_3_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.lay_3_price > 0) {
        if (parseFloat(runner.lay_3_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.back_3_price <= 0) {
        price_exceed_by_limit = true;
      }

      if (runner.lay_3_price <= 0) {
      }
    } else if (
      market_name == "Bookmaker" ||
      market_name == "Bookmaker 2" ||
      market_name == "TIED_MATCH"
    ) {
      if (runner.back_3_price > 0) {
        if (parseFloat(runner.back_3_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.lay_3_price > 0) {
        if (parseFloat(runner.lay_3_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.back_3_price <= 0) {
        price_exceed_by_limit = true;
      }

      if (runner.lay_3_price <= 0) {
      }
    } else {
      if (
        parseFloat(runner.back_3_price) > match_odds_bet_limit ||
        parseFloat(runner.lay_3_price) > match_odds_bet_limit
      ) {
        price_exceed_by_limit = true;
      }

      if (
        parseFloat(runner.back_3_price) <= 0 &&
        parseFloat(runner.lay_3_price) <= 0
      ) {
        price_exceed_by_limit = true;
      }
    }

    // )

    return price_exceed_by_limit;
  };

  useEffect(() => {
    if (userInfo) {
      getGeneralSetting();
      getFancysExposure();
      getChips();
    }
  }, [event_id]);

  function getGeneralSetting() {
    var data = JSON.stringify({
      user_id: userInfo?._id,
      event_id: event_id,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}matchGeneralSetting/getAllGeneralSetting`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          // alert("Hello");
          // console.log('response.data', response.data)
          if (response.data.result) {
            setGeneralSetting(response.data.resultData);
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        console.log(error);
        // postErrorToslack(error.message);
      });
  }

  function getFancysExposure() {
    if (userInfo) {
      var data = JSON.stringify({
        event_id: event_id,
        user_id: userInfo._id,
      });
      var config = {
        method: "post",
        url: `${Appconfig.apiUrl}betting/getFancysExposure`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then(function (response) {
          try {
            if (response.data.resultData.length > 0) {
              setFancyExposure(response.data.resultData);
            }
          } catch (e) {
            console.log(e);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      navigate("/login");
    }
  }

  function getChips() {
    if (userInfo) {
      var data = JSON.stringify({
        user_id: userInfo._id,
      });
      var config = {
        method: "post",
        url: `${Appconfig.apiUrl}chips/getChips`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then(function (response) {
          try {
            if (response.status) {
              setChips(response.data);
            }
          } catch (e) {
            console.log(e);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      navigate("/login");
    }
  }

  const handleOpenBetSlip = (
    event_id,
    market_id,
    is_back,
    size,
    is_fancy,
    selection_id,
    runner_name,
    htmlId,
    PM_FANCY = null,
    market_name,
    runners
  ) => {
    var priceNew = document.getElementById(htmlId).innerHTML;
    setShowBetsSlip(true);
    setSelection_id(selection_id);
    setMarketId(market_id);
    setType(is_back ? "back" : "lay");
    setHtmlId(htmlId);
    setSize(size);
    setIs_fancy(is_fancy);

    if (selection_id) {
      setSelectionIdNew(selection_id);
    }
    // console.log({
    //     'event_id': event_id,
    //     'market_id': market_id,
    //     'is_back': is_back,
    //     'size': document.getElementById(size)?.innerHTML,
    //     'is_fancy': is_fancy,
    //     'selection_id': selection_id,
    //     'runner_name': runner_name,
    //     'new_price': document.getElementById(htmlId)?.innerHTML,
    //     'PM_FANCY': PM_FANCY,
    //     'market_name': market_name,
    // })

    // console.log('yes ')

    let selectElements = document.getElementsByClassName(
      "market_runners_" + market_id.replace(".", "") + "_" + selection_id
    );
    // if (selectElements.length > 0) {
    //     let check_class_exists = document.getElementsByClassName('market_runners_' + market_id.replace('.', '') + '_' + selection_id)[0].classList.contains('disabled');
    //     if (check_class_exists) {
    //         return false;
    //     }

    // }

    setProfitValue(0);
    setStakeValue(0);
    var priceNew = document.getElementById(htmlId).innerHTML;
    var lastFive = market_id.substr(market_id.length - 3);
    if (lastFive == "-BM") {
      priceNew = (priceNew / 100 + 1).toFixed(2);
    } else {
      if (
        market_name == "Bookmaker" ||
        market_name == "Bookmaker 2" ||
        market_name == "TIED_MATCH"
      ) {
        priceNew = (priceNew / 100 + 1).toFixed(2);
      }
    }
    // console.log('priceNew:', priceNew)
    var priceNew = document.getElementById(htmlId).innerHTML;
    setBetPlaceData({
      event_id: event_id,
      market_id: market_id,
      is_back: is_back ? 1 : 0,
      price: priceNew,
      is_fancy: is_fancy,
      selection_id: selection_id,
      runner_name: runner_name,
      bhaw: priceNew,
      PM_FANCY: PM_FANCY,
      runners: runners,
    });
    setShowPlaceBetPopup(true);

    setTimeout(function () {
      SetPosition(0, priceNew, market_id, is_back, selection_id);
      calc(0, priceNew, selection_id);
      placeStakeValue(defaultStake);
    }, 800);
  };

  function formatPrice(price) {
    if (price < 1000) {
      return price;
    }
    const suffixes = ["", "k", "M", "B"];
    const tier = Math.floor(Math.log10(price) / 3);
    const suffix = suffixes[tier];
    const scaledPrice = price / Math.pow(10, tier * 3);
    return `${scaledPrice}${suffix}`;
  }

  function betPlace(ishow) {
    if (userInfo) {
      if (userInfo.user_type == "User") {
        // if (balance > (BetPlaceData.is_fancy ? StakeValue : lossValue)) {
        // console.log({
        //     'balance': balance,
        //     'StakeValue': StakeValue,
        //     'lossValue': lossValue,
        //     'is_fancy' : BetPlaceData.is_fancy
        // });

        setPlacing(true);
        setIsLoading(true);

        var data = JSON.stringify({
          user_id: userInfo._id,
          match_id: BetPlaceData.event_id,
          selection_id: BetPlaceData.selection_id,
          is_back: BetPlaceData.is_back,
          stake: StakeValue,
          price_val: BetPlaceData.price,
          market_id: BetPlaceData.market_id,
          is_fancy: BetPlaceData.is_fancy == 1 ? "Yes" : "No",
          market_name: "Match odds",
          profit: ProfitValue,
          loss: lossValue,
          pm_fancy: BetPlaceData.PM_FANCY,
        });

        var config = {
          method: "post",
          url: `${Appconfig.apiUrl}betting/addBetting`,
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };
        // alert("success");
        axios(config)
          .then(function (response) {
            dispatch(setData(new Date().toISOString()));

            try {
              setPlacing(false);
              setSelection_id("");
              setHtmlId("");
              setProfitValue(0);
              setStakeValue(0);
              setShowBetsSlip(false);

              var data;
              if (userInfo) {
                data = {
                  user_id: userInfo._id,
                  event_id: event_id,
                };
              }
              dispatch(getMatchData(data));
              // getEvents()
              // getFancyData()
              if (userInfo) {
                getFancysExposure();
              }

              if (response.data.result == 0) {
                // console.log('response:', response.data.resultMessage)
                toast.error(response.data.resultMessage);
              } else {
                toast.success(response.data.resultMessage)
                // Close the place bet popup
                setShowPlaceBetPopup(false);
                setBetPlaced(true);
                if (response.data.resultData[0].is_back == 1) {
                  // console.log('place_name:', response.data.resultData[0].place_name)
                  // console.log('stake:', response.data.resultData[0].stake)
                  // console.log('price_val:', response.data.resultData[0].price_val)
                }
                if (response.data.resultData[0].is_back == 0) {
                  // console.log('place_name:', response.data.resultData[0].place_name)
                  // console.log('stake:', response.data.resultData[0].stake)
                  // console.log('price_val:', response.data.resultData[0].price_val)
                }
                setIsBetPlaced(!isBetPlaced);
              }
              var MId = BetPlaceData.market_id.replace(".", "");
              var selectionId = BetPlaceData.selection_id;
              var runners = document.getElementsByClassName("position_" + MId);
              for (var item of runners) {
                var selecid = item.getAttribute("data-id");
                document.getElementById(
                  selecid + "_maxprofit_list_loss_runner_next_" + MId
                ).innerHTML = "";
                document.getElementById(
                  selecid + "_maxprofit_Mlist_loss_runner_next_" + MId
                ).innerHTML = "";
              }
              setBetPlaceData({
                event_id: "",
                market_id: "",
                is_back: "",
                price: "",
                is_fancy: "",
                selection_id: "",
                runner_name: "",
              });
            } catch (e) {
              console.log(e.message);
            }
            setIsLoading(false);
          })
          .catch(function (error) {
            console.log(error);
            console.log(error.message);
            setIsLoading(false);
            setPlacing(false);
          });
        // } else {
        //   toast.error("Insufficient Balance");
        // }
      }
    } else {
      navigate("/login");
    }
  }




  const handleClosePlaceBet = () => {
    setShowPlaceBetPopup(false);
  };

  const handleLiveClick = (e) => {
    e.preventDefault();
    setShowIframe((prevShowIframe) => !prevShowIframe);
  };

  const handleMarketClick = () => {
    setShowMatchStatus(true); // Show match status
    setShowOpenBets(false); // Hide open bets
    setShowIframe(false); // Hide iframe
  };

  const handleOpenBets = () => {
    setShowOpenBets(true); // Toggle Open Bets visibility
    setShowMatchStatus(false); // Hide match status when open bets are shown
  };

  const handleOpenRules = () => {
    navigate("/rules");
  };

  // ...inside your component, before return...
  let team1 = "";
  let team2 = "";
  if (eventName) {
    const teams = eventName.split(/ vs | VS | Vs | v | V |-/i);
    if (teams.length >= 2) {
      team1 = teams[0];
      team2 = teams[1];
    }
  }

  const [matchCurrentPage, setMatchCurrentPage] = useState(1)
  const [fancyCurrentPage, setFancyCurrentPage] = useState(1)
  const itemsPerPage = 10

  // const getOpenBetsByEvent = async () => {
  //   dispatch(
  //     getAllBets({
  //       user_id: userInfo?._id,
  //     }),
  //   )
  // }

  useEffect(() => {
    getOpenBetsByEvent()
  }, [])

  useEffect(() => {
    if (openbets?.bets?.length > 0) {
      const openBetsData = openbets?.bets
      const fancyOpenBets = openBetsData?.filter((fancy) => fancy.betting_type == "Fancy")
      const matchOpenBets = openBetsData?.filter((match) => match.betting_type == "Match")
      setFancyBets(fancyOpenBets)
      setMatchBets(matchOpenBets)
    }
  }, [openbets])

  // console.log("openbets:", openbets)

  // Pagination logic
  const getPaginatedData = (data, currentPage) => {
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    return data.slice(startIndex, endIndex)
  }

  const getTotalPages = (data) => {
    return Math.ceil(data.length / itemsPerPage)
  }

  const renderPagination = (data, currentPage, setCurrentPage) => {
    const totalPages = getTotalPages(data)
    if (totalPages <= 1) return null

    const pages = []
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i)
    }

    return (
      <div className="flex justify-center items-center space-x-2 mt-4">
        <button
          onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className="px-3 py-1 border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
        >
          Previous
        </button>

        {pages.map((page) => (
          <button
            key={page}
            onClick={() => setCurrentPage(page)}
            className={`px-3 py-1 border rounded-md ${currentPage === page ? "bg-blue-500 text-white border-blue-500" : "border-gray-300 hover:bg-gray-50"
              }`}
          >
            {page}
          </button>
        ))}

        <button
          onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className="px-3 py-1 border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
        >
          Next
        </button>
      </div>
    )
  }

  const CustomTable = ({ data, currentPage, setCurrentPage, title }) => {
    const paginatedData = getPaginatedData(data, currentPage)

    return (
      <div className="w-full bg-white">
        {/* The title now has padding instead of margin to keep text off the edge */}
        <div className="">
          <p className="text-lg font-semibold text-gray-800">
            <span>{title}</span>
          </p>
        </div>

        {/* The key change is removing shadow and border from this div */}
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead className="bg-[#028dad]">
              <tr className="">
                <th className=" text-center text-xs font-medium text-white tracking-wider border-r border-white">
                  Event Name
                </th>
                <th className="  text-center text-xs font-medium text-white tracking-wider border-l border-white">
                  Stack
                </th>
                <th className=" text-center py-1 text-xs font-medium text-white tracking-wider border-l border-white">
                  Odds
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {paginatedData.length > 0 ? (
                paginatedData.map((record, index) => (
                  <tr
                    key={record._id || index}
                    className={
                      `hover:bg-gray-50  ` +
                      (record.is_back === 1
                        ? "bg-[#72bbef]"    // Back bet color
                        : "bg-[#faa9ba]")   // Lay bet color
                    }
                  >
                    <td className="px-4 mt- py-1 border-r border-white whitespace-nowrap text-sm text-gray-900">
                      {record?.place_name}
                    </td>
                    <td className="px-4 py-1 border-r border-white whitespace-nowrap text-sm text-gray-900">
                      {record?.stake}
                    </td>
                    <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-900">
                      {record?.price_val}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="px-6 py-8 text-center text-gray-500">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Wrap pagination in a padded div for better spacing */}
        <div className="">
          {renderPagination(data, currentPage, setCurrentPage)}
        </div>
      </div>
    )
  }
  // State for your existing live TV toggle
  // const [showLtv, setShowLtv] = useState(false);

  // 1. Add a new state for the info toggle
  const [showInfo, setShowInfo] = useState(false);

  // A variable from your component's scope, assumed for the example
  // const isInplay = true;

  const [showContent, setShowContent] = useState(false);

  // Handler to toggle the state when the switch is clicked
  const handleSwitchChange = (event) => {
    setShowContent(event.target.checked);
  };

  // Your other state variables
  // const [showLtv, setShowLtv] = useState(true); // /Assuming these are controlled elsewhere
  // const [showScoreIfram, setShowScoreIfram] = useState(false);
  // const [userInfo, setUserInfo] = useState(null);


  return (
    <div>
      <Header />
      <ScrollGames eventType={eventType} setEventType={setEventType} />
      {/* <ExposureHeader /> */}
      <Modal
        title={"Book"}
        className="book-model "
        onCancel={() => setBookModalOpen(false)}
        footer={null}
        open={bookModalOpen}
      >
        <div style={{ padding: "5px", color: "#23282c" }}>
          <div
            style={{
              display: "grid",
              // border: "2px solid #333",
              // borderTop: "1px solid #333",
              width: "100%",
            }}
          >
            <div style={{ backgroundColor: "#e0e6e6", width: "100%" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  width: "100%",
                  borderBottom: "1px solid white",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "5px",
                    borderRight: "1px solid #fff",
                  }}
                >
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    {" "}
                    Run
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "5px",
                    // borderRight: "1px solid #000",
                  }}
                >
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    {" "}
                    Amount
                  </span>
                </div>
              </div>
            </div>


            {postionFancyList.length > 0 ? (



              postionFancyList.map((item, index) => {

                console.log("item:", item);


                if (item < 0)
                  return (
                    <>
                      <div
                        style={{ backgroundColor: "#faa9ba", width: "100%", borderBottom: "1px solid #fff" }}
                      >
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "5px",
                              borderRight: "1px solid #fff",
                            }}
                          >
                            <span
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              {" "}
                              {index}
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "5px",
                              // borderRight: "1px solid #000",
                            }}
                          >
                            <span
                              style={{ color: "red", fontWeight: "bold" }}
                              data-value={item}
                            >
                              {" "}
                              {item}
                            </span>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                if (item >= 0 && item != null)
                  return (
                    <>
                      {/* <Header /> */}
                      <div
                        style={{ backgroundColor: "#72bbef", width: "100%", borderBottom: "1px solid #fff" }}
                      >
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "5px",
                              borderRight: "1px solid #fff",
                            }}
                          >
                            <span
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              {" "}
                              {index}
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "5px",
                              // borderRight: "1px solid #000",
                            }}
                          >
                            <span
                              style={{ color: "green", fontWeight: "bold" }}
                              data-value={item}
                            >
                              {" "}
                              {item}
                            </span>
                          </div>
                        </div>
                      </div>
                    </>
                  );
              })
            ) : (
              <div
                style={{
                  width: "100%",
                  fontWeight: "bold",
                  textAlign: "center",
                  // borderTop: "1px solid",
                  // borderColor: "black",
                }}
              >
                No data!
              </div>
            )}
          </div >
        </div >
      </Modal >
      <div className="matchupdates-container">
        {/* <div className="match-update-header">
        <div className="inside-content">
          <FaPlayCircle size={15} color="white" style={{ marginRight: 5, marginLeft: 5, marginTop: 3 }} />
          <span>{eventName ? eventName : ''}</span>
          <p>{openDate ? openDate : ''}</p>
        </div>
        <IoInformationCircleOutline size={15} color="white" style={{ marginRight: 5, marginLeft: 0, marginTop: 10 }} />
      </div>

      <div className="header-part-2">
        <a href="#" onClick={handleMarketClick}>MARKET</a>
        <a href="#" onClick={handleLiveClick}>
          LIVE <MdLiveTv size={15} color="white" style={{ marginBottom: 2, marginLeft: 2 }} />
        </a>
        <a href="#" onClick={handleOpenBets}>OPEN BETS</a>
      </div> */}

        <div className="match-header-container">
          {/* Top Ribbon */}
          <div className="ribbon-wrapper">
            <div className="ribbon">
              <div className="flex justify-between">
                <span className="event-name">{eventName ? eventName : ""}</span>
                <span className="event-time">{openDate ? openDate : ""}</span>
              </div>

              {/* <svg
                className="ribbon-wave"
                xmlns="http://www.w3.org/2000/svg"
                width="100"
                height="26"
                viewBox="0 0 190 26"
              >
                <path
                  d="M0.208334 0.899998C3.00833 1.4 9.20833 2.6 14.2083 3.4C28.1083 5.9 33.9083 7.6 51.1083 13.9C73.9083 22.5 79.5833 24.7999 93 25.5C107.692 25.4999 116.508 23.5 132.708 17.2C156.308 8 166.008 4.8 177.408 2.4L189.208 0H92.2083C30.8083 0 -2.99167 0.4 0.208334 0.899998Z"
                  fill="#5ecbdd"
                />
              </svg> */}

              {/* <div className="ribbon-deco left" />
              <div className="ribbon-deco right" /> */}
            </div>
          </div>

          {/* Top Icons */}
          <div className="header-icons">
            <div
              className="live-icon"
              onClick={() => {
                setShowLtv((prev) => !prev);
              }}
            >
              {isInplay && (
                <>
                  <span className="ping" />
                  {/* <span className="dot" /> */}
                </>
              )}
              {/* <img
                src="https://bx-s3-dev-001.s3.ap-southeast-1.amazonaws.com/icons/tv.svg"
                alt="TV Icon"
              /> */}
              <div className="flex items-center justify-center flex-row-reverse">
                <Switch size="small" />
                <span>Tv</span>
              </div>
            </div>

            {/* 2. Add the onClick handler to the info icon's div */}
            <div className="info-icon" onClick={() => {
              setShowScore((prev) => !prev);
            }} >
              <div className="flex items-center justify-center flex-row-reverse">
                <Switch size="small" />
                {/* <span className="text-sm">Score</span> */}
                <TbScoreboard />
              </div>
            </div>
          </div>

          {/* Teams Row */}
          {/* <div className="teams-row" >
            {team1 && team2 ? (
              <>
                <div className="team-name left">{team1.trim()}</div>
                <div className="vs">vs</div>
                <div className="team-name right">{team2.trim()}</div>
              </>
            ) : (
              <div className="team-name single">{eventName}</div>
            )}
          </div> */}
        </div>

        {showIframe && (
          <div className="tv-div">
            {showLtv && (
              <div id="streamingBox" className="tv-fix">
                <iframe
                  allowfullscreen="true"
                  webkitallowfullscreen="true"
                  mozallowfullscreen="true"
                  contenteditable="false"
                  frameborder="0"
                  scrolling="yes"
                  id="tvframe"
                  src={tvUrl}
                  style={{
                    width: "100vw",
                    height: "14rem",
                    display: showLtv ? "" : "none",
                  }}
                ></iframe>
              </div>
            )}

            {showScore && (
              <div
                className="score-wrapper border-t-[5px]  border-t-[#c13333]"
                style={{
                  display: showScoreIfram ? "block" : "none",
                  marginTop: userInfo ? "0px" : "18px",
                  backgroundColor: "#000",
                  height: "210px",
                  width: "100%",
                }}
              >
                <iframe
                  onLoad={() => setShowScoreIfram(true)}
                  frameBorder="0"
                  className="score-board"
                  src={scoreUrl}
                  title="match-score"
                  style={{
                    height: "100%", width: "100%",
                    display: showScore ? "" : "none",

                  }}
                />
              </div>
            )}

          </div>
          // <iframe
          //   src="https://www.openstreetmap.org/export/embed.html?bbox=-0.004017949104309083%2C51.47612752641776%2C0.00030577182769775396%2C51.478569861898606&layer=mapnik"
          //   width="100%"
          //   height="200px"
          //   title="Live Match"
          //   style={{ border: "none", marginTop: "10px" }}
          // />
        )}
        {/* {showContent && (
          <div className="tv-div">
            {showLtv && (
              <div id="streamingBox" className="tv-fix">
                <iframe
                  allowfullscreen="true"
                  webkitallowfullscreen="true"
                  mozallowfullscreen="true"
                  contenteditable="false"
                  frameborder="0"
                  scrolling="yes"
                  id="tvframe"
                  src={tvUrl}
                  style={{
                    width: "100vw",
                    height: "14rem",
                    display: showLtv ? "" : "none",
                  }}
                ></iframe>
              </div>
            )}
            <div
              className="score-wrapper border-t-[5px] border-t-[#c13333]"
              style={{
                display: showScoreIfram ? "block" : "none",
                marginTop: userInfo ? "0px" : "18px",
                backgroundColor: "#000",
                height: "210px",
                width: "100%",
              }}
            >
              <iframe
                onLoad={() => setShowScoreIfram(true)}
                frameBorder="0"
                className="score-board"
                src={scoreUrl}
                title="match-score"
                style={{ height: "200px", width: "100%" }}
              />
            </div>
          </div>
        )} */}

        {/* {showOpenBets && (
          <div className="open-bets-section">
            <h2>Open Bets</h2>
            <p>No open bets available.</p>
          </div>
        )} */}

        {/* matchOdds */}
        {/* Top Buttons */}
        <div className="lg:hidden block">
          <div className="matched_bet_box flex  gap-2    bg-[#343a40]">
            {/* Market Button */}
            <div
              className={`match_info_name w-[50%] cursor-pointer inline-flex items-center px-4 py-2 text-sm font-medium ${activeButton === "market" ? "text-white" : "text-white"
                }`}
              onClick={() => setActiveButton("market")}
              style={
                activeButton === "market"
                  ? {
                    backgroundColor: "#5ecbdd",
                    backgroundImage: "linear-gradient(#5ecbdd, #146578)",
                  }
                  : { backgroundColor: "" }
              }
            >
              <span className="market-2">Market</span>
            </div>

            {/* Open Bets Button */}
            <div
              className={`match_info_name w-[50%] cursor-pointer inline-flex items-center  px-4 py-2  text-sm font-medium ${activeButton === "bets"
                ? "text-white"
                : " text-white"
                }`}
              onClick={() => setActiveButton("bets")}
              style={
                activeButton === "bets"
                  ? {
                    backgroundColor: "#5ecbdd",
                    backgroundImage: "linear-gradient(#5ecbdd, #146578)",
                  }
                  : {}
              }
            >
              <span className="market-2">
                Open Bets <span className="betcount">({openBetsCount})</span>
              </span>
            </div>
          </div>
        </div>


        {activeButton == "bets" && (
          <div className="open-bet bg-gray-50">
            <div className="max-w-7xl mx-auto">
              <p className="text-2xl font-bold text-gray-800">
                {/* <span>Open Bets</span> */}
              </p>
              <CustomTable
                data={betsData}
                currentPage={matchCurrentPage}
                setCurrentPage={setMatchCurrentPage}
              // title="Open Bets"
              />
            </div>
          </div>
        )}
        {/* RightSection only when 'bets' is active */}
        {eventData.length > 0 && (
          <div className="match-status">
            {/* <div className="match-status-heading">
            <div className="match-odds-heading">
              <span style={{ marginRight: '5px' }}> {matchOdds?.market_name}</span>
              <svg className="w-[15px] h-[15px] absolute right-[8px] text-[#ffffff] top-[8px] inline-block" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                <path fill="currentColor" fillRule="evenodd" d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 
                5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 
                0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 
                3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 
                7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"></path>
              </svg>
            </div>
            <div>
            <span className="matched-amount" style={{ justifyContent: 'flex-end' }}>
              Matched <span>₹8.10M</span>
            </span>
            </div>
          </div> */}

            <button type="button" className="match-button buttonss">
              <div className="match-button-left">
                <div className="match-label-container">
                  <div className="match-label">
                    <span className="match-label-text">
                      {matchOdds?.market_name || "Match Odds"}
                    </span>
                    <span
                      className="bg-cross"
                      style={{ display: "none" }}
                    ></span>
                  </div>
                </div>
                <div className="cashout-wrapper">
                  <div className="cashout-info">
                    <div className="cashout-box">
                      <div className="cashout-text">Cashout</div>
                    </div>
                  </div>
                </div>
              </div>
              <span className="matched-wrapper">
                <div className="matched-info">
                  <div className="matched-text">
                    Matched: {matchOdds?.matched_amount || "2.7"}
                  </div>
                </div>
              </span>
            </button>

            {/* <div className="back-lay">
              <span className='black'>Back</span>
              <span className='lay'>Lay</span>
            </div> */}
            {/* <table border="1">
            <thead>
              <tr style={{ display: 'flex', justifyContent: 'space-between' }}>
                <th style={{ width: '100%' }} >
                  <td className="min-max">
                    <dt>Min/Max</dt>
                    <dd>100-25000</dd>
                  </td>
                </th>
                <th style={{ display: 'flex' }}>
                  <td className="back">Back</td>
                  <td className="lay">Lay</td>
                </th>
              </tr>
            </thead>
          </table> */}

            {/* <div className="match-header" style={{ padding: '0px', minHeight: '0px' }}>
            <div className="match-minmax">
              <div className="minmax-text mobile">Min: 10 Max: 10K</div>
              <div className="minmax-text desktop">Min: 10 | Max: 10K</div>
            </div>
            <div className="match-columns">
              <div className="col-spacer sm-only"></div>
              <div className="col-spacer sm-only"></div>
              <div className="col-label">BACK</div>
              <div className="col-label">LAY</div>
              <div className="col-spacer sm-only"></div>
              <div className="col-spacer sm-only"></div>
            </div>
          </div> */}

            <div
              className="match-header responsive-header"
              style={{ padding: "0px", minHeight: "0px" }}
            >
              {/* <div className="match-minmax">
                <div className="minmax-text mobile">Min: 10 Max: 10K</div>
                <div className="minmax-text desktop">Min: 10 | Max: 10K</div>
              </div> */}
              <div className="match-minmax">
                <div className="minmax-text mobile">
                  {generalSetting.length > 0
                    ? generalSetting?.map((gen) => {
                      if (
                        (eventType == "Cricket" &&
                          matchOdds?.market_name == "Match Odds" &&
                          gen.event_name == "cricket") ||
                        (eventType == "Soccer" &&
                          gen.event_name == "soccer") ||
                        (eventType == "Tennis" &&
                          gen.event_name == "tennis")
                      ) {
                        return is_inplay == "Inplay"
                          ? `Min: ${gen.min_stake} Max: ${gen.max_stake}`
                          : `Min: ${gen.min_stake} Max: ${gen.pre_inplay_stake}`;
                      } else if (
                        eventType == "Cricket" &&
                        matchOdds?.market_name == "Bookmaker" &&
                        gen.event_name == "bookmaker"
                      ) {
                        return is_inplay == "Inplay"
                          ? `Min: ${gen.min_stake} Max: ${gen.max_stake}`
                          : `Min: ${gen.min_stake} Max: ${gen.pre_inplay_stake}`;
                      }
                    })
                    : "Min: 100 Max: 10k"}
                </div>
                <div className="minmax-text desktop">
                  {generalSetting.length > 0
                    ? generalSetting?.map((gen) => {
                      if (
                        (eventType == "Cricket" &&
                          matchOdds?.market_name == "Match Odds" &&
                          gen.event_name == "cricket") ||
                        (eventType == "Soccer" &&
                          gen.event_name == "soccer") ||
                        (eventType == "Tennis" &&
                          gen.event_name == "tennis")
                      ) {
                        return is_inplay == "Inplay"
                          ? `Min: ${gen.min_stake} | Max: ${gen.max_stake}`
                          : `Min: ${gen.min_stake} | Max: ${gen.pre_inplay_stake}`;
                      } else if (
                        eventType == "Cricket" &&
                        matchOdds?.market_name == "Bookmaker" &&
                        gen.event_name == "bookmaker"
                      ) {
                        return is_inplay == "Inplay"
                          ? `Min: ${gen.min_stake} | Max:${gen.max_stake}`
                          : `Min: ${gen.min_stake} | Max: ${gen.pre_inplay_stake}`;
                      }
                    })
                    : "Min: 100 | Max: 10k"}
                </div>
              </div>
              <div className="match-columns flex items-center gap-[2px]">
                <div className="col-label text-black  bg-[#72bbef] backlay relative lg:right-[17px] ">BACK</div>
                <div className="col-label text-black bg-[#faa9ba] backlay1">LAY</div>
              </div>
            </div>

            <div className="match-details">
              {eventData.length > 0 &&
                eventData.map(
                  (event, index) =>
                    event.marketTypes &&
                    event.marketTypes.length > 0 &&
                    event.marketTypes.map((market, index) =>
                      market.marketRunners &&
                        market.marketRunners.length > 0 &&
                        market.market_name == "Match Odds"
                        ? market.marketRunners.map((runner, i) => (
                          <div
                            className={`odd-even-clr bets-selections all-${event.status
                              } table_row_${market.market_id.replace(
                                ".",
                                ""
                              )}_${runner.selection_id} ${runner.status === "suspended" ? "suspended" : ""
                              } ${checkHighestMarketPrice(
                                runner,
                                market.market_name
                              )
                                ? "disabled"
                                : ""
                              } market_runners_${market.market_id.replace(
                                ".",
                                ""
                              )}_${runner.selection_id}`}
                            key={`Mofmarket${i}`}
                          >
                            <input
                              type="hidden"
                              id="matchodds_id_preserve"
                              value={market.market_id}
                            />
                            <input
                              type="hidden"
                              className={`position_${market.market_id.replace(
                                ".",
                                ""
                              )}`}
                              data-id={runner.selection_id}
                              value={Math.round(runner.exposure.toFixed(2))}
                            />
                            <div className="team-name-box">
                              <div className="tean-runner-name">
                                <span
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <span
                                    id="runnerName"
                                    className="team-name-match"
                                    style={{ color: "#000" }}
                                  >
                                    {runner?.runner_name}
                                  </span>
                                  <span
                                    style={{
                                      marginLeft: "5px",
                                      fontSize: "0.688rem",
                                      color: "#228b22",
                                      fontWeight: "bold",
                                      display: "flex",
                                      textAlign: "left",
                                      alignItems: "center",
                                      gap: "4px",
                                      width: "100%",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <span
                                      id={
                                        runner.selection_id +
                                        "_maxprofit_list_loss_runner_prev_" +
                                        market.market_id.replace(".", "")
                                      }
                                      className={`win market-exposure`}
                                      style={{
                                        fontSize: "0.688rem",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                        marginLeft: "5px",
                                        marginRight: "3px",
                                      }}
                                      data-value={runner.exposure}
                                    >
                                      {Math.abs(runner.exposure.toFixed(2))}
                                    </span>
                                    {showBetsSlip && is_fancy == false && (
                                      <>
                                        {/* <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="10"
                                          height="10"
                                        >
                                          <path
                                            d="M0 3h4v4H0V3zm4 7V0l6 5-6 5z"
                                            fill="#508E0D"
                                            fillRule="evenodd"
                                          />
                                        </svg> */}
                                        <span
                                          id={
                                            runner.selection_id +
                                            "_maxprofit_Mlist_loss_runner_next_" +
                                            market.market_id.replace(".", "")
                                          }
                                          className={`to-win market-exposure `}
                                          style={{
                                            fontSize: "0.688rem",
                                            fontWeight: "bold",
                                            textAlign: "left",
                                          }}
                                        ></span>
                                      </>
                                    )}
                                  </span>
                                </span>
                              </div>
                              <div className="team-number">
                                <span
                                  className={` team-back-number back-1 ${runner.status === "SUSPENDED"
                                    ? "suspended"
                                    : ""
                                    } ${type == "back" &&
                                      selection_id == runner.selection_id &&
                                      runner.back_1_price > 0
                                      ? "bg-highlight "
                                      : ""
                                    }`}
                                  onClick={() =>
                                    handleOpenBetSlip(
                                      event.event_id,
                                      market.market_id,
                                      true, // or false for lay
                                      `MavailableToBack1_size_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                      false,
                                      runner.selection_id,
                                      runner.runner_name,
                                      `MavailableToBack1_price_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                      false,
                                      market.market_name,
                                      market.marketRunners // <-- pass all runners here
                                    )
                                  }
                                  style={{ color: "#000" }}
                                >
                                  <span
                                    id={`MavailableToBack1_price_${market.market_id.replace(
                                      ".",
                                      ""
                                    )}_${runner.selection_id}`}
                                    className="backprice-match "
                                  >
                                    {parseFloat(runner.back_1_price)}
                                  </span>
                                  <span
                                    id={`MavailableToBack1_size_${market.market_id.replace(
                                      ".",
                                      ""
                                    )}_${runner.selection_id}`}
                                    className=""
                                    style={{ fontSize: "10px" }}
                                  >
                                    {parseFloat(runner.back_1_size)}
                                  </span>
                                </span>
                                <span
                                  className={`team-lay-number lay-1 ${runner.status === "SUSPENDED"
                                    ? "suspended"
                                    : ""
                                    } ${type == "lay" &&
                                      selection_id == runner.selection_id &&
                                      runner.lay_1_price > 0
                                      ? "bg-danger"
                                      : ""
                                    }`}
                                  onClick={() =>
                                    handleOpenBetSlip(
                                      event.event_id,
                                      market.market_id,
                                      true, // or false for lay
                                      `MavailableToLay1_size_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                      false,
                                      runner.selection_id,
                                      runner.runner_name,
                                      `MavailableToLay1_price_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                      false,
                                      market.market_name,
                                      market.marketRunners // <-- pass all runners here
                                    )
                                  }
                                  style={{ color: "#000" }}
                                >
                                  <span
                                    id={`MavailableToLay1_price_${market.market_id.replace(
                                      ".",
                                      ""
                                    )}_${runner.selection_id}`}
                                    className="layprice-match"
                                  >
                                    {" "}
                                    {parseFloat(runner.lay_1_price)}
                                  </span>
                                  <span
                                    id={`MavailableToLay1_size_${market.market_id.replace(
                                      ".",
                                      ""
                                    )}_${runner.selection_id}`}
                                    className=""
                                    style={{ fontSize: "10px" }}
                                  >
                                    {parseFloat(runner.lay_1_size)}
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                        ))
                        : ""
                    )
                )}
            </div>
          </div>
        )}

        {/* Toss */}
        {eventData.length > 0 &&
          eventData.map(
            (event, index) =>
              event.marketTypes &&
              event.marketTypes.length > 0 &&
              event.marketTypes.map(
                (market, indexm) =>
                  market.marketRunners &&
                  market.marketRunners.length > 0 &&
                  market.market_name == "Toss" && (
                    <div className="match-status">
                      {/* <div className="match-status-heading-toss" style={{ width: 'fit-content' }}>
                <span style={{ marginRight: '5px' }}>To Win The Toss</span>
                <svg className="w-[15px] h-[15px] absolute right-[8px] text-[#ffffff] top-[8px] inline-block" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                  <path fill="currentColor" fillRule="evenodd" d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 
                  5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 
                  0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 
                  3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 
                  7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"></path>
                </svg>
              </div> */}

                      <button type="button" className="match-button buttonss">
                        <div className="match-button-left">
                          <div className="match-label-container">
                            <div className="match-label">
                              <span className="match-label-text">
                                {/* {toss?.market_name || "Toss"} */}
                                Toss Winner
                              </span>
                              <span
                                className="bg-cross"
                                style={{ display: "none" }}
                              ></span>
                            </div>
                          </div>
                          <div className="cashout-wrapper">
                            <div className="cashout-info">
                              <div className="cashout-box">
                                <div className="cashout-text">Cashout</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <span className="matched-wrapper">
                  <div className="matched-info">
                    <div className="matched-text">
                      Matched: {matchOdds?.matched_amount || "2.7"}
                    </div>
                  </div>
                </span> */}
                      </button>

                      {/* <div className="match-details-toss">

                {
                  market.marketRunners.slice(0, 2).map((runner) => (
                    <div>
                      <div className="team-toss-box">
                        <span
                          className="team-toss"
                        >
                          {runner?.runner_name.split(' ').slice(0, 3).join(' ')}
                        </span>
                      </div>
                      <div className="toss-box-number">
                        <div className="toss-box"
                          onClick={(e) => {
                            handleOpenBetSlip(
                              event.event_id,
                              market.market_id,
                              true,
                              `availableTossBackSize_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                              false,
                              runner.selection_id,
                              runner.runner_name,
                              `availableTossBackPrice_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                              false,
                              market.market_name
                            )

                          }
                          }
                        >
                          <span id={`availableTossBackPrice_${market.market_id.replace('.', '')}_${runner.selection_id}`} className=''>{runner?.back_1_price}</span>
                          <span id={`availableTossBackSize_${market.market_id.replace('.', '')}_${runner.selection_id}`} className='' style={{ fontSize: '10px' }}>{runner?.back_1_size}</span>
                        </div>
                      </div>
                    </div>
                  ))}
              </div> */}

                      <div className="match-details-toss">
                        {market.marketRunners.slice(0, 2).map((runner) => (
                          <div
                            className="toss-row"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                            key={runner.selection_id}
                          >
                            {/* Team Name */}
                            <span className="team-toss text-black" style={{ flex: 2 }}>
                              {runner?.runner_name
                                .split(" ")
                                .slice(0, 3)
                                .join(" ")}
                            </span>
                            {/* Back & Lay Boxes in a single parent */}
                            <div style={{ display: "flex", gap: 0 }}>
                              {/* Back Box */}
                              <div
                                className="toss-box back text-black"
                                style={{
                                  flex: 1,
                                  cursor:
                                    runner.back_1_price > 0
                                      ? "pointer"
                                      : "not-allowed",
                                  minWidth: 60,
                                  textAlign: "center",
                                  background: "#72bbef",
                                  borderRadius: 4,
                                  opacity: runner.back_1_price > 0 ? 1 : 0.5,
                                  margin: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  flexDirection: "column",
                                }}
                                onClick={() => {
                                  if (runner.back_1_price > 0) {
                                    handleOpenBetSlip(
                                      event.event_id,
                                      market.market_id,
                                      true,
                                      `availableTossBackSize_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                      false,
                                      runner.selection_id,
                                      runner.runner_name,
                                      `availableTossBackPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                      false,
                                      market.market_name
                                    );
                                  }
                                }}
                              >
                                <span
                                  id={`availableTossBackPrice_${market.market_id.replace(
                                    ".",
                                    ""
                                  )}_${runner.selection_id}`}
                                  style={{ fontWeight: 600 }}
                                >
                                  {runner?.back_1_price}
                                </span>
                                <span
                                  id={`availableTossBackSize_${market.market_id.replace(
                                    ".",
                                    ""
                                  )}_${runner.selection_id}`}
                                  style={{ fontSize: "10px", marginLeft: 6 }}
                                >
                                  {runner?.back_1_size}
                                </span>
                              </div>
                              {/* Lay Box */}
                              {/* <div
                                className="toss-box lay"
                                style={{
                                  flex: 1,
                                  cursor:
                                    runner.lay_1_price > 0
                                      ? "pointer"
                                      : "not-allowed",
                                  minWidth: 60,
                                  textAlign: "center",
                                  background: "rgb(249, 200, 211)",
                                  borderRadius: 4,
                                  opacity: runner.lay_1_price > 0 ? 1 : 0.5,
                                  margin: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  flexDirection: "column",
                                }}
                                onClick={() => {
                                  if (runner.lay_1_price > 0) {
                                    handleOpenBetSlip(
                                      event.event_id,
                                      market.market_id,
                                      false,
                                      `availableTossLaySize_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                      false,
                                      runner.selection_id,
                                      runner.runner_name,
                                      `availableTossLayPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                      false,
                                      market.market_name
                                    );
                                  }
                                }}
                              >
                                <span
                                  id={`availableTossLayPrice_${market.market_id.replace(
                                    ".",
                                    ""
                                  )}_${runner.selection_id}`}
                                  style={{ fontWeight: 600 }}
                                >
                                  {runner?.lay_1_price}
                                </span>
                                <span
                                  id={`availableTossLaySize_${market.market_id.replace(
                                    ".",
                                    ""
                                  )}_${runner.selection_id}`}
                                  style={{ fontSize: "10px", marginLeft: 6 }}
                                >
                                  {runner?.lay_1_size}
                                </span>
                              </div> */}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
              )
          )}

        {/* bookmaker */}

        {eventData.length > 0 &&
          eventData.map(
            (event, index) =>
              event.marketTypes &&
              event.marketTypes.length > 0 &&
              event.marketTypes.map(
                (market, indexm) =>
                  market.marketRunners &&
                  market.marketRunners.length > 0 &&
                  market.market_name == "Bookmaker" && (
                    <div
                      key={`market-${indexm}`}
                      id="bookMakerMarket_30998640_130561"
                      className="match-status"
                    >
                      <div className="match-status-heading">
                        {/* <div className="bookmaker-heading">
                    <span style={{ marginRight: '5px' }}>{market?.market_name}</span>
                    <svg className="w-[15px] h-[15px] absolute right-[8px] text-[#ffffff] top-[8px] inline-block" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                      <path fill="currentColor" fillRule="evenodd" d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 
                      5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 
                      0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 
                      3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 
                      7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"></path>
                    </svg>
                  </div>
                  <div className="back-lay">
                    <span className="back">Back</span>
                    <span className="lay">Lay</span>
                  </div> */}

                        {/* bookmaker sdtarts here */}
                        <button type="button" className="match-button buttonss">
                          <div className="match-button-left">
                            <div className="match-label-container">
                              <div className="match-label">
                                <span className="match-label-text">
                                  {bookmaker?.market_name || "Bookmaker"}
                                </span>
                                <span
                                  className="bg-cross"
                                  style={{ display: "none" }}
                                ></span>
                              </div>
                            </div>
                            <div className="cashout-wrapper">
                              <div className="cashout-info">
                                <div className="cashout-box">
                                  <div className="cashout-text">Cashout</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <span className="matched-wrapper">
                      <div className="matched-info">
                        <div className="matched-text">
                          Matched: {matchOdds?.matched_amount || "2.7"}
                        </div>
                      </div>
                    </span> */}
                        </button>
                        {/* bookmaker ends here */}
                      </div>
                      {/* <table border="1">
                  <thead>
                    <tr style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <th style={{ width: '215px' }} >
                              <dl className="min-max">
                                  <dt>Min/Max</dt>
                                  <dd>100-25000</dd>
                              </dl>
                          </th>
                      <th style={{ display: 'flex' }}>
                        <td className="back">Back</td>
                        <td className="lay">Lay</td>
                      </th>
                    </tr>
                  </thead>
                </table> */}

                      <div
                        className="match-header responsive-header"
                        style={{ padding: "0px", minHeight: "0px" }}
                      >
                        <div className="match-minmax">
                          <div className="minmax-text mobile">
                            Min: 10 Max: 10K
                          </div>
                          <div className="minmax-text desktop">
                            Min: 10 | Max: 10K
                          </div>
                        </div>
                        <div className="match-columns flex items-center gap-[2px]">
                          <div className="col-label text-black backlay">Yes</div>
                          <div className="col-label text-black backlay1">NO</div>
                        </div>
                      </div>
                      <div
                        className={`match-details ${blockBookmaker &&
                          blockBookmaker?.oddsType == "Suspended" &&
                          "suspended-match"
                          }`}
                      >
                        {" "}
                        {market.marketRunners.map((runner, i) => (
                          <div key={runner.selection_id || i}>
                            {/* <div className={`suspended-container Msuspended_${runner.market_id.replace('.', '')}_${runner.selection_id}`}>
                          <span className="suspended-text">Suspended</span>
                        </div> */}
                            <div
                              className={`odd-even-clr bets-selections all-${event.status
                                } table_row_${market.market_id.replace(
                                  ".",
                                  ""
                                )}_${runner.selection_id} ${runner.status === "suspended" ? "suspended" : ""
                                } ${checkHighestMarketPrice(
                                  runner,
                                  market.market_name
                                )
                                  ? "disabled"
                                  : ""
                                } market_runners_${market.market_id.replace(
                                  ".",
                                  ""
                                )}_${runner.selection_id}`}
                              key={`BMofmarket${i}`}
                            >
                              <input
                                type="hidden"
                                id="matchodds_id_preserve"
                                value={market.market_id}
                              />
                              <input
                                type="hidden"
                                className={`position_${market.market_id.replace(
                                  ".",
                                  ""
                                )}`}
                                data-id={runner.selection_id}
                                value={Math.round(runner.exposure.toFixed(2))}
                              />
                              <div className="team-name-box">
                                <div className="tean-runner-name">
                                  <span
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <span
                                      id="runnerName"
                                      className="team-name-match"
                                      style={{ color: "#000" }}
                                    >
                                      {runner?.runner_name}
                                    </span>
                                    <span
                                      style={{
                                        marginRight: "5px",
                                        fontSize: "0.688rem",
                                        color: "#228b22",
                                        fontWeight: "bold",
                                        display: "flex",
                                        textAlign: "left",
                                        alignItems: "center",
                                        gap: "4px",
                                        width: "100%",
                                        justifyContent: "space-between",

                                      }}
                                    >
                                      <span
                                        id={
                                          runner.selection_id +
                                          "_maxprofit_list_loss_runner_prev_" +
                                          market.market_id.replace(".", "")
                                        }
                                        className={`win market-exposure`}
                                        style={{
                                          fontSize: "0.688rem",
                                          fontWeight: "bold",
                                          textAlign: "left",
                                          marginLeft: "5px",
                                          marginRight: "3px",
                                        }}
                                        data-value={runner.exposure}
                                      >
                                        {Math.abs(runner.exposure.toFixed(2))}
                                      </span>
                                      {showBetsSlip && is_fancy == false && (
                                        <>
                                          {/* <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="10"
                                          height="10"
                                        >
                                          <path
                                            d="M0 3h4v4H0V3zm4 7V0l6 5-6 5z"
                                            fill="#508E0D"
                                            fillRule="evenodd"
                                          />
                                        </svg> */}
                                          <span
                                            id={
                                              runner.selection_id +
                                              "_maxprofit_Mlist_loss_runner_next_" +
                                              market.market_id.replace(".", "")
                                            }
                                            className={`to-win market-exposure `}
                                            style={{
                                              fontSize: "0.688rem",
                                              fontWeight: "bold",
                                              textAlign: "left",
                                            }}
                                          ></span>
                                        </>
                                      )}
                                    </span>
                                  </span>
                                </div>
                                <div className="team-number">
                                  <div
                                    className="match-odds-price-container"
                                    style={{
                                      position: "relative",
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      flex: 1,
                                    }}
                                  >
                                    {/* Overlay shown only when suspended */}
                                    {runner.status === "SUSPENDED" && (
                                      <span className="box-status-overlay box-status-overlay-match">
                                        Suspended
                                      </span>
                                    )}

                                    {/* BACK Box */}
                                    <span
                                      className={`team-back-number back-1 table_row_${market.market_id.replace(
                                        ".",
                                        ""
                                      )}_${runner.selection_id}
                                    ${type === "back" &&
                                          selection_id === runner.selection_id &&
                                          runner.back_1_price > 0 &&
                                          !BetPlaceData.is_fancy
                                          ? "bg-highlight"
                                          : ""
                                        }
                                  `}
                                      onClick={() =>
                                        handleOpenBetSlip(
                                          event.event_id,
                                          market.market_id,
                                          true,
                                          `MavailableToBack1_size_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                          false,
                                          runner.selection_id,
                                          runner.runner_name,
                                          `MavailableToBack1_price_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                          false,
                                          market.market_name,
                                          market.marketRunners
                                        )
                                      }
                                    >
                                      <span
                                        id={`MavailableToBack1_price_${market.market_id.replace(
                                          ".",
                                          ""
                                        )}_${runner.selection_id}`}
                                        className="backprice-match"
                                        style={{ color: "#000" }}
                                      >
                                        {formatPrice(runner.back_1_price)}
                                      </span>
                                      <span
                                        id={`MavailableToBack1_size_${market.market_id.replace(
                                          ".",
                                          ""
                                        )}_${runner.selection_id}`}
                                        style={{
                                          fontSize: "10px",
                                          color: "#000",
                                        }}
                                      >
                                        {formatPrice(runner.back_1_size)}
                                      </span>
                                    </span>

                                    {/* LAY Box */}
                                    <span
                                      className={`team-lay-number lay-1 
                                    ${type === "lay" &&
                                          selection_id === runner.selection_id &&
                                          runner.lay_1_price > 0 &&
                                          !BetPlaceData.is_fancy
                                          ? "bg-danger"
                                          : ""
                                        }
                                  `}
                                      onClick={() =>
                                        handleOpenBetSlip(
                                          event.event_id,
                                          market.market_id,
                                          false,
                                          `MavailableToLay1_size_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                          false,
                                          runner.selection_id,
                                          runner.runner_name,
                                          `MavailableToLay1_price_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                          false,
                                          market.market_name,
                                          market.marketRunners
                                        )
                                      }
                                    >
                                      <span
                                        id={`MavailableToLay1_price_${market.market_id.replace(
                                          ".",
                                          ""
                                        )}_${runner.selection_id}`}
                                        className="layprice-match"
                                        style={{ color: "#000" }}
                                      >
                                        {formatPrice(runner.lay_1_price)}
                                      </span>
                                      <span
                                        id={`MavailableToLay1_size_${market.market_id.replace(
                                          ".",
                                          ""
                                        )}_${runner.selection_id}`}
                                        style={{
                                          fontSize: "10px",
                                          color: "#000",
                                        }}
                                      >
                                        {formatPrice(runner.lay_1_size)}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
              )
          )}

        {/* fancy */}
        <div className="match-status">
          {fancyOddsData.length > 0 && (
            <div className="fancy-market">
              {/* <div className="match-status-heading">
                <div className="fancy-heading">
                  <span style={{ marginRight: '5px' }}>Fancy</span>
                  <svg className="w-[15px] h-[15px] absolute right-[8px] text-[#ffffff] top-[8px] inline-block" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                    <path fill="currentColor" fillRule="evenodd" d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 
                    5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 
                    0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 
                    3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 
                    7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"></path>
                  </svg>
                </div>
              </div> */}

              <button type="button" className="match-button buttonss">
                <div className="match-button-left">
                  <div className="match-label-container">
                    <div className="match-label">
                      <span className="match-label-text">
                        {/* {toss?.market_name || "Toss"} */}
                        Fancy
                      </span>
                      <span
                        className="bg-cross"
                        style={{ display: "none" }}
                      ></span>
                    </div>
                  </div>
                  <div className="cashout-wrapper">
                    <div className="cashout-info">
                      <div className="cashout-box">
                        <div className="cashout-text">Cashout</div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <span className="matched-wrapper">
                  <div className="matched-info">
                    <div className="matched-text">
                      Matched: {matchOdds?.matched_amount || "2.7"}
                    </div>
                  </div>
                </span> */}
              </button>

              <div
                className="match-header responsive-header"
                style={{ padding: "0px", minHeight: "0px" }}
              >
                <div className="match-minmax">
                  <div className="minmax-text mobile">Min: 10 Max: 10K</div>
                  <div className="minmax-text desktop">Min: 10 | Max: 10K</div>
                </div>
                <div className="match-columns">
                  <div className="col-label text-black">No</div>
                  <div className="col-label text-black">Yes</div>
                </div>
              </div>
              {fancyOddsData.map((fancy, index) => (
                <div key={fancy.selection_id || index}>
                  <input
                    type="hidden"
                    id="fancy_id_preserve"
                    value={fancy.market_id}
                  />

                  <div className="fancy-match-details">
                    <div className="team-name-box fancy-box">
                      <span
                        className="team-name"
                        style={{ justifyContent: "flex-start", color: "#000" }}
                      >
                        {" "}
                        {fancy.runner_name}
                        <span
                          id="before"
                          style={{ marginLeft: "10px" }}
                          onClick={() => getFancyPosition(fancy.selection_id)}
                          className={`win fancywin win_${fancy.match_id
                            }_${fancy.selection_id.replace(
                              ".",
                              "___"
                            )} text-[0.688rem]  !font-bold`}
                          data-value={getFancyExposure(fancy.selection_id)}
                        >
                          {checkFancyExposureExists(fancy.selection_id) ? (
                            <>
                              {Math.abs(getFancyExposure(fancy.selection_id))}
                            </>
                          ) : null}
                        </span>
                      </span>
                      <div className="team-number" style={{ color: "#000" }}>
                        {/* BACK & LAY BOXES together */}
                        <div
                          className="fancy-price-container"
                          style={{
                            width: "90%",
                            position: "relative",
                            display: "flex",
                          }}
                        >
                          {/* Overlay for both boxes */}
                          {(fancy.game_status === "SUSPENDED" ||
                            fancy.game_status === "Ball Running") && (
                              <span className="box-status-overlay box-status-overlay-fancy">
                                {fancy.game_status === "SUSPENDED"
                                  ? "Suspended"
                                  : "Ball Running"}
                              </span>
                            )}

                          {/* LAY BOX */}
                          <span
                            className={`team-lay-number ${type === "lay" &&
                              selection_id === fancy.selection_id &&
                              fancy.lay_price1 > 0 &&
                              "bg-highlight"
                              }`}
                            onClick={() =>
                              fancy.lay_price1 > 0 &&
                              handleOpenBetSlip(
                                fancy.match_id,
                                "",
                                false,
                                `fancy_lay_size_${fancy.selection_id}`,
                                true,
                                fancy.selection_id,
                                fancy.runner_name,
                                `fancy_lay_price_${fancy.selection_id}`,
                                false,
                                ""
                              )
                            }
                            style={{ flex: 1 }}
                          >
                            <span
                              className="widthhundredfancy"
                              id={`fancy_lay_price_${fancy.selection_id}`}
                            >
                              {parseFloat(fancy.lay_price1)}
                            </span>
                            <span
                              className="widthhundredfancy"
                              id={`fancy_lay_size_${fancy.selection_id}`}
                              style={{ fontSize: "10px" }}
                            >
                              {parseFloat(fancy.lay_size1)}
                            </span>
                          </span>

                          {/* BACK BOX */}
                          <span
                            className={`team-back-number ${type === "back" &&
                              selection_id === fancy.selection_id &&
                              fancy.back_price1 > 0 &&
                              "bg-danger"
                              }`}
                            onClick={() =>
                              fancy.back_price1 > 0 &&
                              handleOpenBetSlip(
                                fancy.match_id,
                                "",
                                true,
                                `fancy_back_size_${fancy.selection_id}`,
                                true,
                                fancy.selection_id,
                                fancy.runner_name,
                                `fancy_back_price_${fancy.selection_id}`,
                                false,
                                ""
                              )
                            }
                            style={{ flex: 1 }}
                          >
                            <span
                              className="widthhundredfancy"
                              id={`fancy_back_price_${fancy.selection_id}`}
                            >
                              {parseFloat(fancy.back_price1)}
                            </span>
                            <span
                              className="widthhundredfancy"
                              id={`fancy_back_size_${fancy.selection_id}`}
                              style={{ fontSize: "10px" }}
                            >
                              {parseFloat(fancy.back_size1)}
                            </span>
                          </span>
                        </div>

                        {/* Optional: Game status text below or elsewhere */}
                        {/* {fancy.game_status && (
                            <div className="fancy_game_status">
                              <span className="fancy_game_status_update">{fancy.game_status}</span>
                            </div>
                          )} */}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>



        {showPlaceBetPopup && (
          <div className="modal-overlay" onClick={handleClosePlaceBet}>
            <div
              className="modal-content"
              onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside the modal content
            >
              <PlaceBet
                type={type}
                BetPlaceData={BetPlaceData}
                placeStakeValue={placeStakeValue}
                StakeValue={StakeValue}
                chips={chips}
                placing={placing}
                betPlace={betPlace}
                handleClosePlaceBet={handleClosePlaceBet}
                setShowBetsSlip={setShowBetsSlip}
                setSelection_id={setSelection_id}
                setHtmlId={setHtmlId}
              />
            </div>
          </div>
        )}

        {/* {showSuccessPopup && (
          <PlaceBetSuccessfull
            message="Bet placed successfully!"
            onClose={() => setShowSuccessPopup(false)} // Close the success popup
          />
        )} */}



        {/* <Footer /> */}
        <Footer />
      </div>
      <SideBarMenue />
      <RightSection />

    </div >

  );
};

export default MatchUpdates;
